import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form/immutable';
import FormGroup from '../../../components/controls/FormGroup';
import InputSelect from '../../../components/controls/InputSelect';
import MuiButton from '../../../components/controls/MuiButton';
import { defaultFormProperties } from '../../../utilities/form';
import wellnessProgramPaymentResources from '../wellnessProgramPaymentsResources';
import * as validationRules from './partnerPaymentsGenerationFormValidation';
import programPaymentTypesEnum from '../../../enums/programPaymentTypes';

const PatnerPaymentsGenerationForm = ({
    pristine,
    submitting,
    handleSubmit,
    programTypes,
    programPaymentTypes,
    partners,
    onSubmitGenerate,
    onSubmitGenerateWithFees,
    periods,
    onProgramPaymentTypeChange,
    paymentTypes }) => {
    const [isGenerateWithFeesDisabled, setIsGenerateWithFeesDisabled] = useState(false);
    return <FormGroup>
        {
            <>
                <Field
                    label={wellnessProgramPaymentResources.labelProgramType}
                    name={wellnessProgramPaymentResources.fieldProgramPaymentType}
                    options={programPaymentTypes}
                    getOptionLabel={option => option.get('name')}
                    getOptionValue={option => option.get('id')}
                    component={InputSelect}
                    validate={[
                        validationRules.programTypeRequired
                    ]}
                    onChange={(option) => {
                        const programPaymentTypeID = option.get('id');
                        onProgramPaymentTypeChange(programPaymentTypeID);
                        if (programPaymentTypeID === programPaymentTypesEnum.partnerPaid) {
                            setIsGenerateWithFeesDisabled(false);
                        }
                        else {
                            setIsGenerateWithFeesDisabled(true);
                        }
                    }}
                />
                <Field
                    label={wellnessProgramPaymentResources.labelPaymentType}
                    name={wellnessProgramPaymentResources.fieldPaymentType}
                    options={paymentTypes}
                    getOptionLabel={option => option.get('name')}
                    getOptionValue={option => option.get('id')}
                    component={InputSelect}
                    validate={[
                        validationRules.paymentTypeRequired
                    ]}
                />
            </>
        }
        <Field
            label={wellnessProgramPaymentResources.labelPartner}
            name="partner"
            options={partners}
            getOptionLabel={option => option.get('name')}
            getOptionValue={option => option.get('id')}
            component={InputSelect}
            validate={[validationRules.partnerRequired]}
        />
        <Field
            component={InputSelect}
            label={wellnessProgramPaymentResources.labelVisitMonth}
            name="period"
            options={periods}
            getOptionLabel={option => option.get('yearMonth')}
            getOptionValue={option => option.get('id')}
            validate={[validationRules.visitMonthRequired]}
        />
        <div className="grid__row">
            <div className="col-lg-4">
                <MuiButton
                    className="btn_new btn_new--blue"
                    name="buttonGenerate"
                    disabled={pristine || submitting}
                    onClick={handleSubmit(values => onSubmitGenerate(values))}
                >
                    {wellnessProgramPaymentResources.buttonGenerate}
                </MuiButton>
            </div>
            <div className="col-lg-4">
                <MuiButton
                    className="btn_new btn_new--blue"
                    name="buttonGenerateWithFees"
                    disabled={pristine || submitting || isGenerateWithFeesDisabled}
                    size="big"
                    onClick={handleSubmit(values => onSubmitGenerateWithFees(values))}
                >
                    {wellnessProgramPaymentResources.buttonGenerateWithFees}
                </MuiButton>
            </div>
        </div>
    </FormGroup>;
};

PatnerPaymentsGenerationForm.propTypes = {
    pristine: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    programTypes: PropTypes.object.isRequired,
    programPaymentTypes: PropTypes.object.isRequired,
    partners: PropTypes.object.isRequired,
    periods: PropTypes.object,
    onSubmitGenerateWithFees: PropTypes.func.isRequired,
    onSubmitGenerate: PropTypes.func.isRequired,
    onProgramPaymentTypeChange: PropTypes.func.isRequired,
    paymentTypes: PropTypes.object
};

export default reduxForm({
    form: wellnessProgramPaymentResources.formPartnerPaymentsGeneration,
    ...defaultFormProperties
})(PatnerPaymentsGenerationForm);
